if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    connectedCallback() {
      super.connectedCallback();
      if (this.imagePrepareEventsBound) return;
      this.imagePrepareEventsBound = true;
      document.querySelectorAll(`modal-opener[data-modal="#${this.id}"]`).forEach((modalOpener) => {
        const prepare = () => {
          this.prepareImage(modalOpener.querySelector('button[data-media-id]'));
        };
        modalOpener.addEventListener('pointerenter', prepare, { once: true });
        modalOpener.addEventListener('focusin', prepare, { once: true });
        modalOpener.addEventListener('touchstart', prepare, { once: true, passive: true });
      });
    }
    hide() { super.hide(); }
    show(opener) {
      this.prepareImage(opener);
      super.show(opener);
      this.showActiveMedia();
      this.querySelectorAll('img[data-src]').forEach((image) => this.hydrateImage(image));
    }
    prepareImage(opener) {
      const mediaId = opener && opener.getAttribute('data-media-id');
      if (!mediaId) return;
      const image = this.querySelector(`img[data-media-id="${mediaId}"][data-src]`);
      if (!image) return;
      image.loading = 'eager';
      this.hydrateImage(image);
    }
    hydrateImage(image) {
      if (!image || !image.dataset.src) return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
    }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
